export interface AIServiceOptions {
  prompt: string;
  systemPrompt?: string;
  maxTokens?: number;
  temperature?: number;
  topP?: number;
  onUpdate?: (text: string) => Promise<void>; // 流式响应回调
  abortSignal?: AbortSignal;
}

export interface AIServiceResponse {
  text: string;
  error?: string;
}

export interface Message {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

// 定义提供商类型
export type AIProvider = 
  | 'openai' 
  | 'azureopenai' 
  | 'claude' 
  | 'ollama' 
  | 'vllm' 
  | 'lmstudio';

// 基础配置接口
export interface BaseConfig {
  useStreaming?: boolean;
  [key: string]: unknown;
}

// 特定服务配置接口
export interface OpenAIConfig extends BaseConfig {
  apiKey?: string;
  apiUrl?: string;
  model?: string;
  temperature?: number;
  maxTokens?: number;
  topP?: number;
  frequencyPenalty?: number;
  presencePenalty?: number;
}

export interface AzureOpenAIConfig extends BaseConfig {
  apiKey?: string;
  endpoint?: string;
  deploymentName?: string;
  apiVersion?: string;
  temperature?: number;
  maxTokens?: number;
  topP?: number;
  frequencyPenalty?: number;
  presencePenalty?: number;
}

export interface ClaudeConfig extends BaseConfig {
  apiKey?: string;
  model?: string;
  temperature?: number;
  maxTokens?: number;
  topP?: number;
  topK?: number;
  stopSequences?: string;
}

export interface OllamaConfig extends BaseConfig {
  apiUrl?: string;
  model?: string;
  customModel?: string;
  temperature?: number;
  topP?: number;
  topK?: number;
  repeatPenalty?: number;
  contextSize?: number;
}

export interface VLLMConfig extends BaseConfig {
  endpoint?: string;
  model?: string;
  temperature?: number;
  topP?: number;
  topK?: number;
  maxTokens?: number;
  repetitionPenalty?: number;
  presencePenalty?: number;
  frequencyPenalty?: number;
}

export interface LMStudioConfig extends BaseConfig {
  apiUrl?: string;
  model?: string;
  temperature?: number;
  maxTokens?: number;
  topP?: number;
}

// 服务配置类型联合
export type AIServiceConfig =
  | OpenAIConfig
  | AzureOpenAIConfig
  | ClaudeConfig
  | OllamaConfig
  | VLLMConfig
  | LMStudioConfig;

// 基础错误类型
export class AIServiceError extends Error {
  constructor(
    message: string,
    public provider: AIProvider,
    public statusCode?: number,
    public originalError?: Error
  ) {
    super(message);
    this.name = 'AIServiceError';
  }
} 